export default __webpack_public_path__ + "static/media/ReportIcon-Eye-MS.b83b30f5.jpg";